const text = {
  jp: {
    greeting: 'Hello from jp'
  }
};

exports.default = text;